import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * A list page arrived at with ?new=1 opens its create modal at once and
 * drops the parameter, so the palette's "New action item" is the same
 * modal as the page's own button — one path for creation.
 *
 *   useOpenOnNew(() => setShowCreateModal(true));
 */
export default function useOpenOnNew(open) {
  const [searchParams, setSearchParams] = useSearchParams();
  const wanted = searchParams.get('new') === '1';
  const openRef = useRef(open);
  openRef.current = open;
  const handled = useRef(false);

  useEffect(() => {
    if (!wanted || handled.current) return;
    handled.current = true;
    openRef.current();
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete('new');
      return next;
    }, { replace: true });
  }, [wanted, setSearchParams]);
}
